// We expect all React components to be able to support these props,
// which will be rendered as HTML attributes.
export const requiredProps = {
  'aria-label': 'aria-label',
  'className': 'testClass1 testClass2',
  'data-test-id': 'test ID'
};



// WEBPACK FOOTER //
// ./services/test/requiredProps.js